const AdminDashboard = () => {

    return (

        <h2>

            Welcome to PriceWorth Admin

        </h2>

    );

};

export default AdminDashboard;